export enum LOAN_TYPES {
  Auto = 1,
  Powersports = 13,
  RV = 6,
  Boat = 15,
  'Personal Loan' = 7,
  'Signature Loan' = 8,
  'Home Equity' = 18,
  'Credit Card' = 90,
  GSAP = 58,
  'Tractor/Trailer/Implement' = 17,
}

export const AUTO_LOAN_TYPES = [
  LOAN_TYPES.Auto,
  LOAN_TYPES.Powersports,
  LOAN_TYPES.RV,
  LOAN_TYPES['Tractor/Trailer/Implement'],
];

export const LOAN_TYPES_WITH_SUBTYPES: LOAN_TYPES[] = [
  LOAN_TYPES.Powersports,
  LOAN_TYPES['Tractor/Trailer/Implement'],
];

export enum COLLATERAL_CODES {
  Motorcycle = 13,
  ATV = 22,
  UTV = 23,
  'Personal Watercraft' = 24,
  'Tractor/Implement' = 17,
  Trailer = 30,
}

export const COLLATERAL_CODES_BY_LOAN_TYPE: Partial<Record<LOAN_TYPES, COLLATERAL_CODES[]>> = {
  [LOAN_TYPES.Powersports]: [
    COLLATERAL_CODES.Motorcycle,
    COLLATERAL_CODES.ATV,
    COLLATERAL_CODES.UTV,
    COLLATERAL_CODES['Personal Watercraft'],
  ],
  [LOAN_TYPES['Tractor/Trailer/Implement']]: [
    COLLATERAL_CODES['Tractor/Implement'],
    COLLATERAL_CODES.Trailer,
  ],
};

export const EMPLOYMENT_STATUS_OPTIONS = [
  { id: 0, value: 'Employed' },
  { id: 1, value: 'Self-Employed' },
  { id: 2, value: 'Retired' },
  { id: 3, value: 'Unemployed' },
  { id: 4, value: 'Unemployed on Disability' },
];

/**
 * Employment statuses that have no employer section — the applicant supplies no
 * company name. They still carry a status the LOS must receive, so the
 * submission builder emits an employment record for them even without an
 * employer. Employed (0), Self-Employed (1), and Retired (2) always supply an
 * employer, so the employer-presence gate already admits them.
 */
export const NO_EMPLOYER_EMPLOYMENT_STATUS_IDS: readonly number[] = [
  3, // Unemployed
  4, // Unemployed on Disability
];
